import React from 'react';
import styles from './HomeCard.module.css';

export interface HomeCardProps {
  title: string;
  description: string;
  className?: string;
}

export const HomeCard: React.FC<HomeCardProps> = ({ title, description, className }) => {
  return (
    <div className={`${styles.card} ${className}`}>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>{description}</p>
    </div>
  );
};
